class ControlTowerAssociatedItem {
    constructor (data) {
        if (data) {
            this.accountId = data.account_id;
            this.accountName = data.account_name;
            this.articleId = data.article_id;
            this.articleName = data.article_name;
            this.previousData = data.previous_data ? {
                status: data.previous_data.status,
                price: data.previous_data.price,
                originalPrice: data.previous_data.original_price,
                stock: data.previous_data.stock,
                availability: data.previous_data.availability,
                imgUrl: data.previous_data.img_url,
                marketplaceOffers: data.previous_data.marketplace_offers? data.previous_data.marketplace_offers : [],
                additionalData: data.previous_data.additional_data ? data.previous_data.additional_data : {}
            } : {};
            this.currentData = data.current_data ? {
                status: data.current_data.status,
                price: data.current_data.price,
                originalPrice: data.current_data.original_price,
                stock: data.current_data.stock,
                availability: data.current_data.availability,
                imgUrl: data.current_data.img_url,
                marketplaceOffers: data.current_data.marketplace_offers? data.current_data.marketplace_offers : [],
                additionalData: data.current_data.additional_data ? data.current_data.additional_data : {}
            } : {};
            this.supervisorAction = data.supervisor_action;
        }
    }
}

export default ControlTowerAssociatedItem;
